import React, { useState, useEffect } from 'react';
import BalanceSheet from '../components/balancesheet';
import moment from 'moment';
import UserList from "../components/reusable/usersList.jsx";
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import DateRangeWithLine from "../components/reusable/DateSelector1.jsx";
import { useLoginContext } from '../Contexts/LoginContext.js';
import api from '../services/api.js';
import PageHeader from '../components/reusable/PageHeader.jsx';

const Balance = () => {
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [userId, setUserId] = useState('');
  const [admin, setAdmin] = useState(false);
  const [username, setUsername] = useState('');
  const [name,setName]=useState("");
  const [total,setTotal]=useState("");
  const {role}=useLoginContext();

  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      setUsername(location.state.username);
      setName(location.state.name);
      setTotal(location.state.total);
    }
  }, [location.state]);



  useEffect(() => {
      try {
        if (role === "admin") {
          setAdmin(true);
        } else {
          setAdmin(false);
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        setAdmin(false);
      }
  }, [role]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.post(`/singleUser`, { userId });
        setName(response.data[0].name);
        setUsername(response.data[0].username);
        setTotal(response.data[0].total);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    if (userId) {
      fetchData();
    }
  }, [userId]);

  const handleDateRangeSelection = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const handleUserSelect = (selectedUserId) => {
    setUserId(selectedUserId);
  };



  return (
    <>
      <div className="p-1  w-full  mx-auto md:overflow-y-scroll ">
          <PageHeader title="BalanceSheet"/>
        <div className="bg-white p-4 md:p-6 rounded-lg shadow-md ">
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 items-center">
    
    {/* Select User (Admin only) */}
    {admin && (
      <div className="relative">
        <label
          htmlFor="user-select"
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          Select User
        </label>
        <div className="relative">
          <UserList onSelectUser={handleUserSelect} selectedUser={username} />
        </div>
      </div>
    )}

    {/* Date Range Picker */}
    <div className="relative">
      <label
        htmlFor="date-range"
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        Date Range
      </label>
      <div className="relative">
        <DateRangeWithLine handleChange={handleDateRangeSelection} />
      </div>
    </div>

  </div>
</div>
        <div className="h-full w-full">
          {/* Render BalanceSheet only after date range selection */}
          {
            <Routes>
              <Route
                path="*"
                element={
                  <BalanceSheet
                    startDate={startDate}
                    endDate={endDate}
                    userId={userId}
                    admin={admin}
                    role={role}
                  />
                }
              />
            </Routes>
          }
        </div>
      </div>
    </>
  );
};

export default Balance;